import React from "react";
import "./newUser.css";
const NewUser = () => {
  return (
    <div className="newUser">
      <h1 className="newUser_title">New User</h1>
      <form action="" className="newUser_form">
        <div className="newUser_item">
          <label>Username</label>
          <input type="text" placeholder="Jaran" />
        </div>
        <div className="newUser_item">
          <label>Full Name</label>
          <input type="text" placeholder="Jaran" />
        </div>
        <div className="newUser_item">
          <label>Email</label>
          <input type="text" placeholder="Jaran" />
        </div>
        <div className="newUser_item">
          <label>Password</label>
          <input type="text" placeholder="Jaran" />
        </div>
        <div className="newUser_item">
          <label>Phone</label>
          <input type="text" placeholder="Jaran" />
        </div>
        <div className="newUser_item">
          <label>Gender</label>
          <div className="newUser_gender">
            <input type="radio" name="gender" id="male" value="male" />
            <label for="male">Male</label>
            <input type="radio" name="gender" id="female" value="female" />
            <label for="male">Female</label>
            <input type="radio" name="gender" id="ohter" value="ohter" />
            <label for="male">Other</label>
          </div>
        </div>
        <div className="newUser_item">
          <label>Active</label>
          <select name="active" id="active" className="newUser_select">
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        <button className="newUser_button">Create</button>
      </form>
    </div>
  );
};

export default NewUser;
